/* 
  Author: Prasuk
  Info  : This file covers the miscelenous function required for store.js
        The functions mentioned are totally dependent on the main file and need not work for other purpose
*/
module.exports = {
  FilterInspSummByDate : (docs, dtFrom, dtTo)=>{
    //Filter Inspection Summary by Date
    
      var x= new Date()
      var to = new Date(dtTo)
      var from = new Date(dtFrom)
      var ViewDoc=[]
      // console.log(docs)
      for ( var doc in docs){
        // console.log(docs[doc]);
        
        x=new Date(docs[doc].inspection_date)
    
        
        if ( x <= to  ){
        if (x < from) break;
          ViewDoc.push(docs[doc])
        }
      }
      // console.log(ViewDoc);
      
      return ViewDoc
    }
  
}
